export default class AnnualReportFilter {

    public pageNumber = 1;

    public pageSize = 20;

    public companyId: number | null = null;

    public type: string | null = null;

    public year: number | null = null;

    public state: string | null = null;

}
